import { flex } from '../../../styled-system/patterns';
import { css } from '../../../styled-system/css';
import { DeleteAccount } from '#/features/myPage/components/DeleteAccount/DeleteAccount';
import { LoginAndSecurity } from '#/features/myPage/components/loginAndSecurity/LoginAndSecurity';
import { Organizations } from '#/features/myPage/components/organizations/Organizations';
import { useAccount } from '#/features/myPage/hooks/useAccount';
import { useTitle } from '#/utils/useTitle';
import { useLoginRequired } from '#/utils/auth/useLoginRequired';
import { GenericError } from '#/components/Error';
import { useEmailResendDialog } from '#/features/myPage/hooks/useEmailResendDialog';
import { useVerificationEmail } from '#/features/myPage/hooks/useVerificationEmail';
import { useMfaResetAlertDialog } from '#/features/myPage/hooks/useMfaResetAlertDialog';
import { useAuthenticationMethods } from '#/features/myPage/hooks/useMfa';
import { IS_UNIVERSITY_OPENING } from '#/utils/env';

export function MyPage() {
  useLoginRequired();
  useTitle('マイページ');
  const { data: account, error: accountError } = useAccount();
  // MFA未登録時の場合は、authenticationMethodsがnullとなる、エラー時はundefinedとなる
  const { data: authenticationMethods, error: authenticationMethodError } = useAuthenticationMethods();
  const verificationEmail = useVerificationEmail();
  const emailResendDialog = useEmailResendDialog({ sendVerificationEmail: verificationEmail.sendVerificationEmail });
  const mfaAlertDialog = useMfaResetAlertDialog(authenticationMethods);
  if (accountError || verificationEmail.error || authenticationMethodError) {
    return (
      <div className={flex({ width: '100%', flexDirection: 'column' })}>
        <div
          className={flex({
            paddingTop: '{spacing.20}',
            paddingBottom: '{spacing.40}',
            width: '100%',
            sm: {
              paddingTop: '{spacing.40}',
              paddingBottom: '{spacing.56}',
            },
          })}
        >
          <GenericError />
        </div>
      </div>
    );
  }
  return (
    account &&
    authenticationMethods !== undefined && (
      <div className={flex({ width: '100%', flexDirection: 'column' })}>
        <div className={css({ padding: '40px 0' })}>
          <LoginAndSecurity
            account={account}
            emailResendDialog={emailResendDialog}
            verificationEmail={verificationEmail}
            mfaAlertDialog={mfaAlertDialog}
            authenticationMethods={authenticationMethods}
          />
        </div>
        <div className={flex({ flexDirection: 'column', paddingBottom: '56px' })}>
          <Organizations
            // 開学までは所属情報を表示しない
            currentMemberships={IS_UNIVERSITY_OPENING ? account.currentMemberships : []}
            pastMemberships={IS_UNIVERSITY_OPENING ? account.pastMemberships : []}
          />
          <DeleteAccount />
        </div>
      </div>
    )
  );
}
